export function initIOSCursorFix(inputSelector = '.algoliaAutocompleteForm__input') {
    if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) return;

    let isFixing = false;

    document.addEventListener('focusin', function(e) {
        if (e.target.matches(inputSelector) && !isFixing) {
            isFixing = true;
            const input = e.target;

            input.style.caretColor = 'transparent';

            setTimeout(() => {
                input.style.caretColor = '';
                input.setSelectionRange(input.value.length, input.value.length);
                setTimeout(() => isFixing = false, 100);
            }, 300);
        }
    });
}